export default __webpack_public_path__ + "static/media/Ellipse 91.315af7bb.png";